const options = {
  name: 'Reset Password',
  suppressFormValues: true
};

const fields = {
  user_email: {
    label: 'Email address',
    rules: 'required|email'
  },
  recaptcha: {}
};

export { fields, options };
